<template>
  <v-app class="application-wrapper">
    <preloader :load="preloading" />
    <vue-snotify />
    <main-header
        :notifications="notifications"
    />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { SETTINGS_GETTERS, SETTING_ACTIONS } from "@/store/modules/settings";
  import { CART_MUTATIONS } from "@/store/modules/cart-context";
  import { APP_GETTERS, APP_ACTIONS } from "@/store/modules/app";
  import { ERRORS_GETTERS, ERRORS_ACTIONS } from '@/store/modules/errors';
  import { NOTIFICATIONS_GETTERS } from '@/store/modules/notifications';
  import { MainHeader } from '@/layouts';
  import Preloader from '@/shared/components/Loaders/Preloader.vue';

  export default {
    name: 'App',
    components: {
      MainHeader,
      Preloader,
    },
    mounted() {
      if (!this.lang) { this.lang = this.setLang(); }
      if (!this.currency) { this.currency = this.setCurrency(); }
      if (!this.authorization) { this.authorization = this.setAuth(); }
    },
    created() {
      this.$i18n.locale = this.lang.toLowerCase();
      this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { language: this.lang });
      this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { currency: this.currency });
    },
    computed: {
      ...mapGetters('settings', {
        lang: SETTINGS_GETTERS.LANG,
        currency: SETTINGS_GETTERS.CURRENCY,
        authorization: SETTINGS_GETTERS.AUTH,
      }),
      ...mapState('notifications', {
        notifications: NOTIFICATIONS_GETTERS.ALL,
      }),
      ...mapState('errors', {
        errors: ERRORS_GETTERS.ALL,
      }),
      ...mapGetters("app", {
        preloading: APP_GETTERS.PRELOADING,
        breadcrumbs: APP_GETTERS.BREADCRUMBS,
      }),
    },
    watch: {
      errors() {
        this.errors.map(error => {
          this.$notify('error', 'Error', error.data.message);
          return this.removeFromCache();
        });
      },
      lang() {
        this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { language: this.lang });
      },
      currency() {
        this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { currency: this.currency });
      }
    },
    methods: {
      ...mapActions('errors', {
        removeFromCache: ERRORS_ACTIONS.REMOVE_FROM_CACHE,
      }),
    }
  }
</script>

<style scoped>
  .v-application.application-wrapper {
    overflow: hidden;
  }
</style>
